var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 38,
    viewBox: "0 0 42 38",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.6096118 8.5 6.75 27h-40.7192236l6.75-27z",
    fill: "#8bb7f0",
    stroke: "#4a6790"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 4,
    r: 4,
    stroke: "#4a6790",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero",
    transform: "translate(13.246094 15.726562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3125 6.2578125h-.03125v-6.2578125h-2.28125v11.2734375h2.28125v-2.765625l.59375-.640625 2.3984375 3.40625h2.625l-3.3515625-4.78125 3.1953125-3.59375h-2.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.421875 9.4921875c-1.1328125 0-1.8359375-.890625-1.8359375-2.421875 0-1.5234375.7109375-2.4765625 1.8359375-2.4765625 1.140625 0 1.8671875.96875 1.8671875 2.4765625 0 1.515625-.7265625 2.421875-1.8671875 2.421875zm-.0390625 4.9375c2.5078125 0 4.1796875-1.2734375 4.1796875-3.2734375v-8.2578125h-2.25v1.4609375h-.0390625c-.4375-.9609375-1.3828125-1.59375-2.5859375-1.59375-2.125 0-3.4375 1.6328125-3.4375 4.2890625 0 2.6171875 1.3515625 4.1953125 3.3984375 4.1953125 1.2109375 0 2.1953125-.609375 2.5859375-1.5h.046875v1.46875c0 .96875-.65625 1.625-1.8359375 1.625-.8671875 0-1.5234375-.3984375-1.703125-.9765625h-2.234375c.1796875 1.4921875 1.671875 2.5625 3.875 2.5625z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMass);
export default __webpack_public_path__ + "static/media/mass.e2b2a102c1f901e72ca9675d833a7ce1.svg";
export { ForwardRef as ReactComponent };